// Story 11034: the Disclosure Status column the My Files and Assigned Files grids show, defined once here so the
// grids that list the same columns cannot drift apart on it.
export const DISCLOSURE_ORDERED_FIELD = 'hasDisclosureOrdered';
export const DISCLOSURE_STATUS_FIELD = 'disclosureStatus';
export const DISCLOSURE_STATUS_HEADER = 'Disclosure Status';

// The ways a grid sizes a column (the My Files grids by flex between a minimum and a maximum, the Assigned Files grids
// by a fixed width)
const SIZING_KEYS = ['width', 'minWidth', 'flex', 'maxWidth'];
const sizingOf = (column) => Object.fromEntries(SIZING_KEYS.filter((key) => key in column).map((key) => [key, column[key]]));

/**
 * Inserts the Disclosure Status column immediately to the right of "Disclosure has been ordered?" (the story's
 * placement), sized as that neighbour is, and sorting and filtering like every other plain text column. The value is
 * the status label, or nothing for an interaction without one (legacy interactions included); "Other" shows as
 * "Other", never the explanation.
 */
export const withDisclosureStatus = (columns) => {
    const at = columns.findIndex((column) => column.field === DISCLOSURE_ORDERED_FIELD);
    if (at < 0) throw new Error(`The grid has no "${DISCLOSURE_ORDERED_FIELD}" column to place "${DISCLOSURE_STATUS_HEADER}" after`);
    const disclosureStatus = { ...sizingOf(columns[at]), field: DISCLOSURE_STATUS_FIELD, headerName: DISCLOSURE_STATUS_HEADER, editable: false };
    return [...columns.slice(0, at + 1), disclosureStatus, ...columns.slice(at + 1)];
};
